
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEventMarkerFilled as ObiEventMarkerFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-event-marker-filled.js';
 
 
 

 
 export const ObiEventMarkerFilled = createComponent({
   react: React,
   tagName: 'obi-event-marker-filled',
   elementClass: ObiEventMarkerFilledElement,
   events: {
     
   }
  });
 
 